import { render } from "./payment-confirmation.component.vue?vue&type=template&id=60758da5&ts=true"
import script from "./payment-confirmation.component.vue?vue&type=script&lang=ts"
export * from "./payment-confirmation.component.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__